import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/porting_/loa_/$loaId')({
  staticData: { team: 'fe-clm' },
});
